import React, { useState } from "react";
import { motion } from "framer-motion";
import Details from "./RoomDetails/details";
import PageHero from "../../components/PageHero";
import { Link } from "react-router-dom";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "auto",
  });
};

const rooms = [
  {
    id: 1,
    name: "Single Room",
    imgSrc: "/images/general/single_room.jpeg",
    details: {
      amenities: [
        "Free Wi-Fi.",
        "Cable TV.",
        "Complementary Tea & Coffee.",
        "Water Kettle.",
        "Complementary 2 Bottles of water per day.",
        "Essentials (Towels, Soap, Shampoo & Moisturizer)",
        "Balcony",
        "Laundry Services.",
        "Air Condition in all rooms.",
        "Mini Freezer",
        "Hair Dryer.",
      ],
      localRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.2100" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.2450",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.3050",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.3900",
        },
      ],
      internationalRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.2100" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.2450",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.3100",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.4000",
        },
      ],
    },
  },
  {
    id: 2,
    name: "Twin Room",
    imgSrc: "/images/general/twin_bed_room.jpeg",
    details: {
      amenities: [
        "Free Wi-Fi.",
        "Cable TV.",
        "Complementary Tea & Coffee.",
        "Water Kettle.",
        "Complementary 2 Bottles of water per day.",
        "Essentials (Towels, Soap, Shampoo & Moisturizer)",
        "Balcony",
        "Laundry Services.",
        "Air Condition in all rooms.",
        "Mini Freezer",
        "Hair Dryer.",
      ],
      localRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.2800" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.3150",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.3750",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.4600",
        },
      ],
      internationalRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.3400" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.4100",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.5400",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.6850",
        },
      ],
    },
  },
  {
    id: 3,
    name: "Deluxe Room",
    imgSrc: "/images/general/deluxe_room.jpg",
    details: {
      amenities: [
        "Free Wi-Fi.",
        "Cable TV.",
        "Complementary Tea & Coffee.",
        "Water Kettle.",
        "Complementary 2 Bottles of water per day.",
        "Essentials (Towels, Soap, Shampoo & Moisturizer)",
        "Balcony",
        "Laundry Services.",
        "Air Condition in all rooms.",
        "Mini Freezer",
        "Hair Dryer.",
      ],
      localRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.3300" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.3650",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.4250",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.5100",
        },
      ],
      internationalRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.2700" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.3050",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.3700",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.4600",
        },
      ],
    },
  },
  {
    id: 4,
    name: "Suite 1 Room",
    imgSrc: "/images/general/Suite_1.jpeg",
    details: {
      amenities: [
        "Free Wi-Fi.",
        "Cable TV.",
        "Complementary Tea & Coffee.",
        "Water Kettle.",
        "Complementary 2 Bottles of water per day.",
        "Essentials (Towels, Soap, Shampoo & Moisturizer)",
        "Balcony",
        "Laundry Services.",
        "Air Condition in all rooms.",
        "Mini Freezer",
        "Hair Dryer.",
      ],
      localRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.4200" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.4550",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.5150",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.6000",
        },
      ],
      internationalRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.3200" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.3550",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.4200",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.5100",
        },
      ],
    },
  },
  {
    id: 5,
    name: "Suite 2 Room",
    imgSrc: "/images/general/Suite_2rt.jpeg",
    details: {
      amenities: [
        "Free Wi-Fi.",
        "Cable TV.",
        "Complementary Tea & Coffee.",
        "Water Kettle.",
        "Complementary 2 Bottles of water per day.",
        "Essentials (Towels, Soap, Shampoo & Moisturizer)",
        "Balcony",
        "Laundry Services.",
        "Air Condition in all rooms.",
        "Mini Freezer",
        "Hair Dryer.",
      ],
      localRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.3600" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.3900",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.4500",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.5300",
        },
      ],
      internationalRates: [
        { plan: "European Plan", facilities: "Only Room", price: "Nu.3700" },
        {
          plan: "Continental Plan",
          facilities: "Room with Breakfast",
          price: "Nu.4050",
        },
        {
          plan: "Modified American Plan",
          facilities: "Room with Breakfast & any one meal",
          price: "Nu.4700",
        },
        {
          plan: "American Plan",
          facilities: "Room with all Three meals",
          price: "Nu.5600",
        },
      ],
    },
  },
];

const Rooms = () => {
  const [selectedRoom, setSelectedRoom] = useState(null);

  const textEffect = { offscreen: { opacity: 0, y: 40 }, onscreen: { opacity: 1, y: 0, transition: { duration: .8, ease: [0.16, 1, 0.3, 1] } } };

  const handlePreviousRoom = () => {
    const currentIndex = rooms.findIndex((room) => room.id === selectedRoom.id);
    const previousIndex = (currentIndex - 1 + rooms.length) % rooms.length;
    setSelectedRoom(rooms[previousIndex]);
  };

  const handleNextRoom = () => {
    const currentIndex = rooms.findIndex((room) => room.id === selectedRoom.id);
    const nextIndex = (currentIndex + 1) % rooms.length;
    setSelectedRoom(rooms[nextIndex]);
  };
  const handleViewRoomDetails = (room) => {
    scrollToTop(); // Scroll to top when viewing room details
    setSelectedRoom(room);
  };

  return (
    <motion.div className="bg-[#F8F5EF] text-[#14274A]">
      {selectedRoom ? (
        <Details
          room={selectedRoom}
          onBack={() => setSelectedRoom(null)}
          onPrevious={handlePreviousRoom}
          onNext={handleNextRoom}
          showPrevious={selectedRoom.id !== rooms[0].id}
          showNext={selectedRoom.id !== rooms[rooms.length - 1].id}
        />
      ) : (
        <>
          <PageHero image="/images/general/roomsLanding.svg" eyebrow="Rest easy" title="Rooms with soul" copy="Thoughtful spaces shaped by comfort, natural tones and the quiet character of Bhutan." />
          <motion.div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 lg:py-32">
            <motion.div className="mx-auto flex max-w-3xl justify-center text-center">
              <motion.h1
                className="section-title"
                variants={textEffect}
                initial={"offscreen"}
                whileInView={"onscreen"}
                viewport={{ once: true }}
              >
                Find your private retreat
              </motion.h1>
            </motion.div>

            <motion.p
              className="section-copy mx-auto mt-7 max-w-3xl text-center"
              variants={textEffect}
              initial={"offscreen"}
              whileInView={"onscreen"}
              viewport={{ once: true }}
            >
              Each of our bright, light-flooded rooms come with everything you
              could possibly need for a comfortable stay. And yes, comfort isn’t
              our only objective, we also value good design, sleek contemporary
              furnishing complemented by the rich tones of nature’s palette as
              visible from our rooms’ sea-view windows and terraces.
            </motion.p>

            <motion.div className="grid grid-cols-1 gap-9 py-20 md:grid-cols-2">
              {rooms.map((room, index) => (
                <motion.div
                  key={room.id}
                  className={`group flex w-full flex-col overflow-hidden bg-white shadow-[0_18px_60px_rgba(20,39,74,.08)] transition-shadow duration-500 hover:shadow-[0_24px_75px_rgba(20,39,74,.14)] ${index === rooms.length - 1 ? "md:col-span-2 md:mx-auto md:w-[calc(50%_-_1.125rem)]" : ""}`}
                  variants={textEffect}
                  initial={"offscreen"}
                  whileInView={"onscreen"}
                  viewport={{ once: true }}
                >
                  <div className="relative h-[350px] overflow-hidden">
                    <motion.img src={room.imgSrc} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" alt={room.name} />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#14274A]/55 via-transparent to-transparent" />
                    <span className="absolute left-5 top-5 bg-[#14274A]/85 px-3 py-2 font-montserrat text-[8px] font-bold uppercase tracking-[.18em] text-white backdrop-blur-sm">Breakfast included</span>
                    <span className="absolute bottom-5 right-5 font-garamond text-2xl italic text-white/75">0{room.id}</span>
                  </div>
                  <div className="flex flex-1 flex-col px-7 py-7 sm:px-8">
                    <div className="flex items-start justify-between gap-5 border-b border-[#14274A]/10 pb-5">
                      <div><p className="font-montserrat text-[8px] font-bold uppercase tracking-[.2em] text-[#9f7a36]">Private retreat</p><h3 className="mt-1 font-garamond text-3xl font-medium">{room.name}</h3></div>
                      <div className="text-right"><span className="block font-montserrat text-[8px] uppercase tracking-[.14em] text-[#14274A]/40">From</span><strong className="font-garamond text-xl font-medium">{room.details.localRates[0].price}</strong></div>
                    </div>
                    <div className="flex flex-wrap gap-x-5 gap-y-2 py-5 font-montserrat text-[9px] uppercase tracking-[.12em] text-[#14274A]/52"><span>Wi-Fi</span><span>Air conditioning</span><span>Balcony</span></div>
                    <div className="mt-auto flex items-center justify-between gap-4 border-t border-[#14274A]/10 pt-5">
                      <button onClick={() => handleViewRoomDetails(room)} className="font-montserrat text-[9px] font-bold uppercase tracking-[.16em] text-[#14274A] transition hover:text-[#9f7a36]">View details <span className="ml-1 text-[#E0B973]">→</span></button>
                      <Link to="/booking" className="bg-[#E0B973] px-5 py-3 font-montserrat text-[9px] font-bold uppercase tracking-[.15em] text-[#14274A] transition hover:bg-[#ebc989]">Book now</Link>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </>
      )}
    </motion.div>
  );
};

export default Rooms;
